var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00186 0.333496C6.12638 0.333496 5.25948 0.505935 4.45064 0.840966C3.6418 1.176 2.90688 1.66706 2.28782 2.28612C1.03758 3.53636 0.335197 5.23205 0.335197 7.00016C0.329369 8.53959 0.862392 10.0325 1.84186 11.2202L0.50853 12.5535C0.416025 12.6472 0.353361 12.7663 0.328445 12.8956C0.303529 13.0249 0.317478 13.1588 0.36853 13.2802C0.423902 13.4001 0.513667 13.5009 0.626428 13.5698C0.73919 13.6386 0.869864 13.6724 1.00186 13.6668H7.00186C8.76997 13.6668 10.4657 12.9645 11.7159 11.7142C12.9662 10.464 13.6685 8.76827 13.6685 7.00016C13.6685 5.23205 12.9662 3.53636 11.7159 2.28612C10.4657 1.03588 8.76997 0.333496 7.00186 0.333496ZM7.00186 12.3335H2.60853L3.22853 11.7135C3.3527 11.5886 3.42239 11.4196 3.42239 11.2435C3.42239 11.0674 3.3527 10.8984 3.22853 10.7735C2.35559 9.90152 1.81198 8.75386 1.69032 7.52603C1.56867 6.2982 1.87649 5.06617 2.56135 4.03984C3.2462 3.01352 4.26572 2.2564 5.44621 1.89748C6.62669 1.53855 7.8951 1.60003 9.03534 2.07144C10.1756 2.54284 11.1171 3.39501 11.6995 4.48276C12.2819 5.5705 12.4691 6.82653 12.2293 8.03683C11.9895 9.24714 11.3374 10.3369 10.3842 11.1203C9.43104 11.9038 8.23571 12.3325 7.00186 12.3335Z",
    fill: "#9AA0A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.0ccdd19ba56f20e69bcbbea0edd22688.svg";
export { ForwardRef as ReactComponent };